import { useQueryClient } from "@tanstack/react-query";
import { plannedRoutesQueryKey } from "./usePlannedRoutes";
import { deliveryRoutesKeys } from "./useDeliveryRoutes";

/**
 * Hook to invalidate all relevant queries after adding/removing from plan.
 * Used by useAddToPlan and useRemoveFromPlan hooks.
 */
export function useInvalidateQueriesAfterPlanChange() {
  const queryClient = useQueryClient();

  const invalidateQueriesAfterPlanChange = (date: number, sicId: number) => {
    // 1. Invalidate planned routes (planning grid sidebar)
    queryClient.invalidateQueries({
      queryKey: plannedRoutesQueryKey(date, sicId),
    });

    // 2. Invalidate ALL traps queries (Pre-Planning Traps tab - green indicator)
    queryClient.invalidateQueries({
      queryKey: ["traps"],
    });

    // 3. Invalidate delivery routes summary (route/trap counts)
    queryClient.invalidateQueries({
      queryKey: deliveryRoutesKeys.deliveryRoutesSummary(sicId, date),
    });

    // 4. Invalidate shipment details
    queryClient.invalidateQueries({
      queryKey: ["planning", "shipment-details"],
    });

    // 5. Invalidate unassigned shipments
    queryClient.invalidateQueries({
      queryKey: ["unassigned", "shipments", date, sicId],
    });

    // 6. Invalidate linehaul trip queries (Unplanned Freight - IBLH Trailers)

    queryClient.invalidateQueries({
      queryKey: ["tripsLinehaul"],
    });

    // 7. Invalidate LH stops queries (Unplanned Freight - IBLH Trailers)

    queryClient.invalidateQueries({
      queryKey: ["tripsLHStops"],
    });

    // 8. Invalidate shuttle trip queries (Unplanned Freight - Shuttles)

    queryClient.invalidateQueries({
      queryKey: ["tripsShuttle"],
    });

    // 9. Invalidate Freight on Dock queries

    queryClient.invalidateQueries({
      queryKey: ["freightOnDock"],
    });

    // 10. Invalidate Incomplete Trailers queries

    queryClient.invalidateQueries({
      queryKey: ["incompleteTrailers"],
    });
  };

  return invalidateQueriesAfterPlanChange;
}
